import React, { useEffect, useState } from "react";
import { Grid, Typography, List, ListItem } from "@mui/material";
import { simpleFetchQuestion } from "../actions/fetchQuestion";
import { StringDiff } from "react-string-diff";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function QuestionReview({ answer, index, isTeacher }) {
  const [question, setQuestion] = useState({});
  useEffect(() => {
    simpleFetchQuestion(answer.question).then((res) => setQuestion(res));
  }, [answer]);

  const grading_type_dict = {
    "exact": "Exact Match",
    "levenshtein": "Minimum Edit Distance",
    "checklist": "Checklist"
  }

  return (
    question && (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          fontSize={24}
          align="center"
          //sx={{ pb: "15px" }}
        >
          <Typography variant="h5">{`Question ${index + 1}`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container direction="column">
            <Grid container item direction = "row">
              <Grid item xs={6} align = "left">
                <Typography variant="subtitle1">
                  Grading method: {grading_type_dict[question.grading_type]}
                </Typography>
              </Grid>
              <Grid item xs={6} align ="right">
                <Typography variant="subtitle1">{`Score: ${Math.round(answer.grade * question.points*100)/100}/${
                  question.points
                } points`}</Typography>
              </Grid>
            </Grid>
            
            {question.grading_type === "checklist" && (
              <>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">{`${
                    isTeacher ? "Student" : "Your"
                  } Answer: ${answer.answer}`}</Typography>
                </Grid>
                <Grid item>
                  <Typography>
                    Conditional Checklist:
                  </Typography>
                  <List>
                    {question.checklist.map((singleQuestion, index) => {
                      return (
                        <ListItem
                          divider
                          key={index}
                          sx={{ color: answer.testResults[index] ? "green" : "red" }}
                        >
                          {singleQuestion}
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
                {question?.answer && (
                  <Grid item>
                    <Typography variant="subtitle1">
                      Possible Solution: {question?.answer}
                    </Typography>
                  </Grid>
                )}
              </>
            )}
            {(question?.grading_type === "levenshtein" ||
              question?.grading_type === "exact") && (
              <>
                <Grid item container>
                  <Typography variant="subtitle1">
                    Requirements:
                    <ul>
                      {question?.requirements.map((requirement) => {
                        return(
                          <li key={requirement}>{requirement}</li>
                        )
                      })}
                    </ul>
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography variant="subtitle1">Errors: </Typography>
                  <Typography variant="subtitle1">
                    <StringDiff oldValue={question.answer} newValue={answer.answer} />
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          </AccordionDetails>
      </Accordion>
    )
  );
}
